import axios from 'axios'
import {getApiUrls,getApiUpdateUrls} from "@/http/base.http";

export function getDevice(payload) {
    const { env } = getApiUrls();
    return axios.post(`${env}device/get`, payload).then(res => {
        axios.defaults.baseURL = res.data
        return res.data
    })
}
export function addDevice(payload) {
    const { env } = getApiUrls();
    return axios.post(`${env}device/add`,payload).then(res => {
        axios.defaults.baseURL = res.data
        return res.data
    })
}
export function ddDeviceType() {
    const { env } = getApiUrls();
    return axios.get(`${env}dropdown/device/type/dd`).then(res => {
        axios.defaults.baseURL = res.data
        return res.data
    })
}
export function ddComponent() {
    const { env } = getApiUrls();
    return axios.get(`${env}dropdown/component/dd`).then(res => {
        axios.defaults.baseURL = res.data
        return res.data
    })
}
export function ddHub() {
    const { env } = getApiUrls();
    return axios.get(`${env}dropdown/hub/dd`).then(res => {
        axios.defaults.baseURL = res.data
        return res.data
    })
}
export function ddAsset() {
    const { env } = getApiUrls();
    return axios.get(`${env}dropdown/asset/dd`).then(res => {
        axios.defaults.baseURL = res.data
        return res.data
    })
}
export function getByDevice(id) {
    const { env } = getApiUrls();
    return axios.get(`${env}device/detail/${id}`).then(res => {
        axios.defaults.baseURL = res.data
        return res.data
    })
}
export function updateDevice(payload) {
    const {envU } = getApiUpdateUrls();
    return axios.put(`${envU}device/update`,payload).then(res => {
        axios.defaults.baseURL = res.data
        return res.data
    })
}